import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router';

import { select } from '@swf/core/store';

const useCheckHGPath = (): boolean => {
  const { homeGamesLandingPage = '' } = useSelector(select.cms.getAliases);
  const { pathname } = useLocation();

  const match = matchPath(pathname, { path: homeGamesLandingPage, exact: false, strict: false });
  return !!match;
};

export default useCheckHGPath;
